import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useAuth} from '../..'
import {useTranslation} from 'react-i18next'
import ChangePassword from './ChangePassword'

const UserProfile = () => {
  const {t} = useTranslation()
  const {currentUser} = useAuth()

  return (
    <>
      <div className='container-fluid card mb-5 mb-xl-10 p-none'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-8 mb-4'>
              <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                <img src={toAbsoluteUrl('/media/avatars/photo.jpg')} alt='Metornic' />
                <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>
              </div>
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div>
                  <div className='d-flex align-items-center mb-2'>
                    <p className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                      {currentUser?.name}
                      <KTIcon iconName='verify' className='fs-1 text-success pt-1' />
                    </p>
                  </div>

                  <div className='fw-bold fs-6 mb-4 pe-2'>
                    <p className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                      <span className='mx-2'>{t('GLOBAL.USERNAME')}:</span>
                      {currentUser?.username}
                    </p>
                    <p className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                      <span className='mx-2'>{t('PROFILE.ROLE')}:</span>
                      {currentUser?.roles}
                    </p>
                    <p className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                      <span className='mx-2'>{t('PROFILE.EMAIL')}:</span>
                      {currentUser?.email}
                    </p>
                  </div>
                </div>

                <div className='d-flex my-4'>
                  <div className='mx-3'>
                    <button
                      className='btn btn-sm btn-info btn-active-dark fw-bolder mx-2'
                      data-kt-menu-trigger='click'
                      data-kt-menu-placement='bottom-end'
                      data-kt-menu-flip='top-end'
                    >
                      <i className='fas fa-lock mx-2'></i>
                      {t('PROFILE.CHANGE_PASSWORD')}
                    </button>
                    <ChangePassword />
                  </div>

                  <Link to='/dashboard' className='btn btn-sm btn-primary fw-bolder'>
                    <i className='fa-solid fa-circle-left mx-2'></i>
                    {t('BUTTONS.BACK')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile
